import { getZoneJsOriginalValue } from '../tools/getZoneJsOriginalValue';
import { monitor } from '../tools/monitor';
export function setTimeout(callback, delay) {
    return getZoneJsOriginalValue(window, 'setTimeout')(monitor(callback), delay);
}
export function clearTimeout(timeoutId) {
    getZoneJsOriginalValue(window, 'clearTimeout')(timeoutId);
}
//# sourceMappingURL=timer.js.map